var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07128 0.278417L0.745129 6.32784C0.41829 6.69906 0.41829 7.30093 0.745129 7.67216L6.07128 13.7216C6.39812 14.0928 6.92803 14.0928 7.25487 13.7216C7.58171 13.3504 7.58171 12.7485 7.25487 12.3773L2.52051 7L7.25487 1.62273C7.58171 1.25151 7.58171 0.64964 7.25487 0.278417C6.92803 -0.0928058 6.39812 -0.0928058 6.07128 0.278417Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.080df7bd3c5bb4df80f422bf6acfc929.svg";
export { ForwardRef as ReactComponent };